<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import type { LeftCenterAlign } from '$lib/types/Components/SharedTypes';

    export let narrow = false;
    export let medium = false;
    export let wide = false;
    export let fullHeight = false;
    export let desktop = false;
    export let align: LeftCenterAlign = 'center';

    let classes: string;

    $: classes = cn('fun-w-full fun-max-w-md sm:fun-max-w-xl', {
        'md:fun-max-w-3xl': medium,
        'fun-mx-auto': align === 'center',
        'md:fun-max-w-3xl lg:fun-max-w-4xl': !narrow && !wide && !medium,
        'md:fun-max-w-3xl lg:fun-max-w-5xl': wide,
        'fun-h-full': fullHeight,
        'md:fun-max-w-screen-md lg:fun-max-w-screen-lg xl:fun-max-w-screen-xl 2xl:fun-max-w-screen-2xl':
            desktop,
    });
</script>

<div class={classes}>
    <slot />
</div>
